import gql from 'graphql-tag'

export const fetchBonus = bonus_id => {
	return {
		query: gql`
			query ($bonus_id: bigint!) {
				bonus: bonuses_by_pk(id: $bonus_id) {
					title
					country_id
					company_id
					body
					valid_from
					valid_until
					roles: bonuses_roles {
						id: rol_id
					}
					image {
						file_name
						mime
						url
						id
					}
				}
			}
		`,
		variables: { bonus_id }
	}
}
